module.exports = __webpack_public_path__ + "img/floor_f7_02.e3248318.png";